import {KeycloakService} from 'keycloak-angular';
import {UserSessionService} from './shared/services/user-session.service';
import {AppService} from "./app.service";

// load the Keycloak JavaScript adapter
export function initializeKeycloak(keycloak: KeycloakService, userSessionService: UserSessionService): () => Promise<any> {
  return (): Promise<any> => {
    const config = AppService.getConfig();
    const urlParams = new URLSearchParams(window.location.search);
    const idpHint = urlParams.get('idp') || urlParams.get('idpHint') || urlParams.get('kc_idp_hint');

    return keycloak.init({
      config: config.keycloak.config,
      initOptions: {
        checkLoginIframe: config.keycloak.initOptions.checkLoginIframe,
        onLoad: 'check-sso',
        pkceMethod: 'S256'
      }
    }).then((authenticated) => {
      if (!authenticated) {
        const loginOptions: Keycloak.KeycloakLoginOptions = {};
        if (idpHint) {
          loginOptions.idpHint = idpHint;
        }
        return keycloak.login(loginOptions);
      }
      return userSessionService.loadUserProfile();
    });
  };
}

